export default __webpack_public_path__ + "static/tour-example3-03db8af97cfea946f4d3902dec0b7db5.png";